import { render } from "./App.vue?vue&type=template&id=c862dc0e"
const script = {}

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__